import { Row, Table } from "antd";
import { discountsService } from "api";

import { STATUS_CARD } from "assets/constants/card-types";
import { ListActionButton, ModalCustom } from "components/common";

import React, { useEffect, useRef, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { ColumnsEdit } from "types/models/column-table-edit";
import DiscountsAdd from "./DiscountsAdd";

const Discount = () => {
  const action = useAppSelector((state) => state.receive.dataPassing);
  const [dataTable, setDataTable] = useState([]);
  const [dataRecord, setDataRecord] = useState([]);

  const openModalRef = useRef<any>(null);

  console.log("🚀 ~ Discount ~ dataTable:", dataTable);
  const columns: ColumnsEdit = [
    {
      title: "STT",
      dataIndex: "stt",
      show: true,
      render: (v, r, i) => i + 1,
      align: "center",
    },
    {
      title: "Tên chương trình",
      dataIndex: "tenChuongTrinh",
      show: true,
    },
    // {
    //   title: "Tên gói dịch vụ",
    //   show: true,
    //   align: "center",
    //   dataIndex: "dichVuUuDais",
    //   children: [
    //     {
    //       title: "",
    //       dataIndex: "dichVuDtos",
    //       children: [
    //         {
    //           title: "",
    //           dataIndex: "tenDichVu",
    //         },
    //       ],
    //     },
    //   ],
    // },
    // {
    //   title: "Tên dịch vụ",
    //   dataIndex: "maLoaiThe",
    //   show: true,
    //   align: "center",
    // },
    // {
    //   title: "Giá trị hoá đơn từ",
    //   dataIndex: "maLoaiThe",
    //   show: true,
    //   align: "center",
    // },
    {
      title: "Số lần áp dụng còn lại",
      dataIndex: "soLanApDungConLai",
      show: true,
      align: "left",
    },
    // {
    //   title: "Giảm giá",
    //   dataIndex: "trangThai",
    //   show: true,
    //   align: "left",
    //   render: (v, r, i) => "Hiệu lực",
    // },
    // {
    //   title: "Giảm giá tối đa",
    //   dataIndex: "soLuotBan",
    //   show: true,
    //   align: "center",
    // },
    {
      title: "Trạng thái",
      dataIndex: "soLuotBan",
      show: true,
      align: "center",
      render: () => "Hiệu lực",
    },
    {
      title: "Thao tác",
      dataIndex: "soLuotBan",
      show: true,
      align: "center",
      render: (v, record) => (
        <ListActionButton showDetailFunction={() => handleShowDetail(record)} />
      ),
    },
  ];

  const handleShowDetail = (record) => {
    setDataRecord(record);
    openModalRef.current.openModal();
  };

  const searchKM = async () => {
    const nguonBN = JSON.parse(localStorage.getItem("nguonBN")) ?? [];

    try {
      const res = await discountsService.searchKM({
        loaiKCB: action.loaiKcb,
        trangThai: 1,
        doiTuong: action.doiTuong,
        nguonBn: nguonBN?.find((el) => el.label === action.nguonBn)?.value,
      });
      setDataTable(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    searchKM();
  }, [action]);

  return (
    <Row>
      <Table
        columns={columns}
        dataSource={dataTable}
        pagination={false}
        bordered
      />
      <ModalCustom title={"Chương trình khuyến mãi"} ref={openModalRef}>
        <DiscountsAdd data={dataRecord} />
      </ModalCustom>
    </Row>
  );
};

export default Discount;
